var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8095 8.02876L14.2567 1.23949C14.1981 1.16797 14.1258 1.10982 14.0444 1.06869C13.963 1.02757 13.8742 1.00437 13.7837 1.00056C13.6932 0.996753 13.6029 1.01241 13.5186 1.04656C13.4342 1.0807 13.3576 1.13259 13.2935 1.19894C13.2295 1.2653 13.1794 1.34468 13.1465 1.43209C13.1135 1.5195 13.0984 1.61303 13.1021 1.7068C13.1057 1.80056 13.1281 1.89251 13.1678 1.97686C13.2075 2.06121 13.2636 2.13614 13.3327 2.19689L18.765 7.83215L1.63063 7.83215C1.4612 7.83883 1.30086 7.91327 1.18328 8.03982C1.06569 8.16638 0.999999 8.33522 0.999999 8.51089C0.999999 8.68655 1.06569 8.85539 1.18328 8.98195C1.30086 9.10851 1.4612 9.18294 1.63063 9.18962L18.765 9.18962L13.3327 14.818C13.2636 14.8788 13.2075 14.9537 13.1678 15.038C13.1281 15.1224 13.1057 15.2143 13.1021 15.3081C13.0984 15.4019 13.1135 15.4954 13.1465 15.5828C13.1794 15.6702 13.2295 15.7496 13.2935 15.8159C13.3576 15.8823 13.4342 15.9342 13.5186 15.9683C13.6029 16.0025 13.6932 16.0181 13.7837 16.0143C13.8742 16.0105 13.963 15.9873 14.0444 15.9462C14.1258 15.9051 14.1981 15.8469 14.2567 15.7754L20.8095 8.98615C20.9315 8.8589 21 8.68682 21 8.50746C21 8.32809 20.9315 8.156 20.8095 8.02876Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.58f7ae2429de0450a9ae0525cf0473ba.svg";
export { ForwardRef as ReactComponent };